import { Button } from "@ameelio/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  OrganizationMembership,
  OrganizationMembershipRole,
} from "../api/graphql";
import useApolloErrorHandler from "../lib/handleApolloError";
import { useCurrentMembership } from "../SessionBoundary";
import EditOrganizationMembershipModal from "./EditOrganizationMembershipModal";
import RemoveOrganizationMembershipModal from "./RemoveOrganizationMembershipModal";

type Props = {
  organizationMembership: Pick<OrganizationMembership, "id" | "role"> & {
    visitor: { fullName: string };
  };
};

export default function OrganizationMembershipActionsMenu({
  organizationMembership,
}: Props) {
  const { t } = useTranslation();
  const handleApolloError = useApolloErrorHandler();
  const navigate = useNavigate();

  const { role } = useCurrentMembership();
  const isAdmin = role === OrganizationMembershipRole.Admin;
  const isTargetAdmin =
    organizationMembership.role === OrganizationMembershipRole.Admin;

  const [showEditModal, setShowEditModal] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        disabled={!isAdmin}
        disabledReason={t("Only organization admins may change roles")}
        onClick={() => setShowEditModal(true)}
        sx={{ flexGrow: 1 }}
      >
        {t("Edit")}
      </Button>
      {showEditModal && (
        <EditOrganizationMembershipModal
          organizationMembership={organizationMembership}
          onClose={() => setShowEditModal(false)}
          onRemove={
            isTargetAdmin
              ? undefined
              : () => {
                  setShowEditModal(false);
                  setShowRemoveModal(true);
                }
          }
        />
      )}
      {showRemoveModal && (
        <RemoveOrganizationMembershipModal
          organizationMembershipId={organizationMembership.id}
          onSuccess={() => navigate(-1)}
          onCancel={() => setShowRemoveModal(false)}
          onFail={(e) => {
            setShowRemoveModal(false);
            handleApolloError(e);
          }}
        />
      )}
    </>
  );
}
